import styled from 'styled-components';

export const MarketingHeader = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__MarketingHeader", componentId: "sc-7zoax2-0" })(["display:flex;align-items:flex-start;margin-bottom:", ";"],


({ theme }) => theme.spacers.L);


export const Image = /*#__PURE__*/styled.img.withConfig({ displayName: "styles__Image", componentId: "sc-7zoax2-1" })(["height:64px;width:64px;display:block;"]);





export const LargeImage = /*#__PURE__*/styled.img.withConfig({ displayName: "styles__LargeImage", componentId: "sc-7zoax2-2" })(["display:block;overflow:hidden;border-radius:4px;object-fit:cover;width:100%;max-height:256px;"]);